import { ITourMainProps } from '@monofe/ui-workspace/tour/interface';
import { IBaseControllerRenderResult } from '../interface';

export interface IRouteTourArguments {
    db: string;
    languageId: number;
    tourId: number;
    sessionName: string;
}

export interface ITourControllerProps {
    didRequestSiteObject: (id: number) => void;
    didRequestFloorPlan: (id: number) => void;
    didRequestLanguageSelect: () => void;
    didRequestTourSelect: () => void;
    didRequestBack: () => void;
    route: IRouteTourArguments;
}

export interface ISiteObjectSelectControllerRenderResult
    extends IBaseControllerRenderResult<{ siteObjectId: any }> {}

export enum ITourType {
    Undef = 0,
    List = 1,
    Cascaded = 2,
    Keypad = 3,
    Hamburger = 4,
    LastValue = 5,
}

export interface ITourStateActionModifier {
    (model: ITourMainProps): ITourMainProps;
}
